module.exports = "/_next/static/images/785c5e33a31d1d746a7c698cb05ecb51-mgm-md-2.png.webp";